import React, { useState } from 'react';
import ReviewOutlinedSVG from 'src/assets/svg/review-outlined.svg';
import { Base, Button } from 'src/components';
import { Flyout } from 'src/componentsTailwind';
import Checkbox from 'src/components/Checkbox/Checkbox';
import CircledIcon from 'src/components/CircledIcon/CircledIcon';

const PdfSettingsFlyout = (props = {}) => {
  const { setIsOpen, onDownload } = props;

  const [includeOpenFeedbackComments, setIncludeOpenFeedbackComments] = useState(false);
  const [
    includePerformanceCompetenciesComments,
    setIncludePerformanceCompetenciesComments
  ] = useState(false);
  const [includeGoalsComments, setIncludeGoalsComments] = useState(false);

  const onSubmitFlyout = async () => {
    await onDownload({
      includeOpenFeedbackComments,
      includePerformanceCompetenciesComments,
      includeGoalsComments
    });
    setIsOpen(false);
  };

  const cancel = () => setIsOpen(false);

  return (
    <Flyout {...props}>
      <Base
        classes='h-full w-full items-center flex flex-col items-stretch justify-between'
        relative
      >
        <div className='mb-10'>
          <div className='flex items-center'>
            <CircledIcon svg={<ReviewOutlinedSVG className='text-purple' />} />
            <h2 className='text-xl font-bold my-auto mt-2 p-0'>
              Download Options
            </h2>
          </div>

          <p className='m-0 p-0'>
            Customize what's included in the PDF export.
          </p>

          <div className='mt-10 border-b border-mid-gray my-3 transform -translate-x-[16px] w-[calc(100%+32px)]' />

          <h1 className='text-black m-0 p-0 text-base'>
            Include Feedback Comments
          </h1>
          <p className='m-0 p-0'>
            Adds all feedback comments or goal updates to the report export.
            Keep in mind that some feedback may not have been intended to be
            shared directly.
          </p>

          <p className='m-0 p-0 my-4'>
            Select sections to display additional details for:
          </p>

          <Checkbox
            label='Open Feedback'
            name='openFeedback'
            onChange={setIncludeOpenFeedbackComments}
            value={includeOpenFeedbackComments}
            classes='text-base'
          />
          <Checkbox
            label='Performance Competencies'
            name='performanceCompetencies'
            onChange={setIncludePerformanceCompetenciesComments}
            value={includePerformanceCompetenciesComments}
            classes='text-base'
          />
          <Checkbox
            label='Goals'
            name='goals'
            onChange={setIncludeGoalsComments}
            value={includeGoalsComments}
            classes='text-base'
          />

          <p className='italic text-sm gray mt-3'>
            Note: Exports do not typically include these additional details.
          </p>
        </div>

        <div className='flex flex-row flex-wrap w-full max-w-280 gap-4 h-9 2xl:h-[39.5px] xl:ml-auto xl:mr-0 justify-center xl:justify-end'>
          <Button
            type='button'
            variant='empty-with-border'
            classes='!rounded-md !text-sm !font-normal py-1 xl:ml-auto xl:mr-0 h-full'
            onClick={cancel}
          >
            Cancel
          </Button>
          <Button
            classes='bg-[#0F172A] text-white text-sm     py-1 rounded-md transition-colors duration-300 h-full px-6'
            variant='custom'
            onClick={onSubmitFlyout}
          >
            Download
          </Button>
        </div>
      </Base>
    </Flyout>
  );
};
export default PdfSettingsFlyout;
